// Simple fetch wrapper; customize if you already have one
const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

export const makeHeaders = (tenantId, extra = {}) => {
  const h = {
    'Content-Type': 'application/json',
    ...(tenantId ? { 'x-tenant-id': String(tenantId) } : {}),
    ...extra,
  };
  return h;
};

export const getJson = async (url, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, { credentials: 'include', ...opts });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};

export const patchJson = async (url, body, opts = {}) => {
  const res = await fetch(`${BASE_URL}${url}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};
